import type {DatasetOrdering} from './../../../../../../../dss-core/src/main/java/com/dataiku/dip/input/dataset-ordering';
import type {FilterDesc} from './../../../../../../../dss-core/src/main/java/com/dataiku/dip/dataflow/exec/filter/filter-desc';
import type {SamplingParam} from './sampling-param';

/**
 * Generated from com.dataiku.dip.datasets.DatasetSelection
 */
export interface DatasetSelection extends SamplingParam {
    filter: FilterDesc;
    latestPartitionsN: number;
    ordering: DatasetOrdering;
    partitionSelectionMethod: DatasetSelection.PartitionSelectionMethod;
    selectedPartitions?: string[] | null;
}

export namespace DatasetSelection {
    /**
     * Generated from com.dataiku.dip.datasets.DatasetSelection$PartitionSelectionMethod
     */
    export enum PartitionSelectionMethod {
        ALL = 'ALL',
        SELECTED = 'SELECTED',
        LATEST_N = 'LATEST_N'
    }
}